import { Link } from "react-router-dom";

const SiteFooter = () => (
  <footer className="border-t border-brass/15 bg-ink" data-testid="site-footer">
    <div className="mx-auto max-w-7xl px-5 py-14 sm:px-8 sm:py-20">
      <div className="grid gap-12 md:grid-cols-[1.4fr_1fr_1fr]">
        <div>
          <div className="flex items-center gap-3">
            <img
              src="/assets/players-lounge-logo.png"
              alt=""
              className="h-10 w-10 object-contain"
            />
            <span className="font-serif text-xl text-ivory">
              Players <span className="italic text-brass">Lounge</span>
            </span>
          </div>
          <p className="mt-5 max-w-sm text-sm leading-relaxed text-ivory/60">
            Private, curated gatherings for men in Sydney.
            <span className="mt-1 block text-brass/80">
              ♠ Play Freely. ♥ Play Hard. ♦ Play Safe. ♣ Play Again.
            </span>
          </p>
          <p className="mt-4 text-[11px] uppercase tracking-[0.25em] text-ivory/40">
            Sydney · 18+ · Private events
          </p>
        </div>
        <nav aria-label="Footer explore">
          <p className="text-[11px] uppercase tracking-[0.3em] text-brass">Explore</p>
          <ul className="mt-4 space-y-2.5 text-sm">
            {[
              ["/", "Home"],
              ["/the-game", "The Game"],
              ["/the-players", "The Players"],
              ["/house-rules", "House Rules"],
              ["/first-game", "First Game?"],
              ["/lounges", "Upcoming Lounges"],
            ].map(([to, label]) => (
              <li key={to}>
                <Link
                  to={to}
                  data-testid={`footer-link-${label.toLowerCase().replace(/[^a-z]+/g, "-")}`}
                  className="text-ivory/65 transition-colors hover:text-brass"
                >
                  {label}
                </Link>
              </li>
            ))}
          </ul>
        </nav>
        <nav aria-label="Footer connect">
          <p className="text-[11px] uppercase tracking-[0.3em] text-brass">Connect</p>
          <ul className="mt-4 space-y-2.5 text-sm">
            <li>
              <Link to="/deal-me-in" data-testid="footer-link-deal-me-in" className="text-ivory/65 transition-colors hover:text-brass">
                Deal Me In
              </Link>
            </li>
            <li>
              <Link to="/contact" data-testid="footer-link-contact" className="text-ivory/65 transition-colors hover:text-brass">
                Contact
              </Link>
            </li>
            <li>
              <Link to="/privacy" data-testid="footer-link-privacy" className="text-ivory/65 transition-colors hover:text-brass">
                Privacy
              </Link>
            </li>
            <li>
              <Link to="/terms" data-testid="footer-link-terms" className="text-ivory/65 transition-colors hover:text-brass">
                Terms &amp; Conditions
              </Link>
            </li>
            <li>
              <a
                href="mailto:hello@playersloungesyd.com"
                data-testid="footer-link-email"
                className="text-ivory/65 transition-colors hover:text-brass"
              >
                hello@playersloungesyd.com
              </a>
            </li>
            <li>
              <a
                href="https://x.com/playerslngsyd"
                target="_blank"
                rel="noopener noreferrer"
                data-testid="footer-link-x"
                className="text-ivory/65 transition-colors hover:text-brass"
              >
                Follow us on X
              </a>
            </li>
          </ul>
        </nav>
      </div>
      <div className="mt-14 border-t border-brass/10 pt-6">
        <p className="text-xs leading-relaxed text-ivory/45">
          Players Lounge gatherings are held at private Sydney addresses. Venue details are only
          ever shared with confirmed Players shortly before each event.
        </p>
        <div className="mt-4 flex flex-wrap items-center justify-between gap-3 text-[11px] uppercase tracking-[0.2em] text-ivory/35">
          <span>© 2026 Players Lounge Sydney</span>
          <span>Men 18+ only · No photos · No judgement · No pressure</span>
        </div>
      </div>
    </div>
  </footer>
);

export default SiteFooter;
